import React, { useEffect, useState } from 'react';
import { PillTextbox } from '../types';
import { setPillPaddingLeft, setPillPaddingRight } from '../utils/pill-accessors';
import { usePillContent } from '../hooks/use-pill-content';
import { labelStyle, rowStyle, sectionStyle, sliderStyle, valueLabelStyle } from './pill-styles';

type Props = { pill: PillTextbox };

/** Shows a slider for the pill's anchor-facing padding (paddingLeft or paddingRight
 *  depending on attachTo.side). Hidden when the pill has no attachTo. */
export const PillChainPaddingRow: React.FC<Props> = ({ pill }) => {
  const { content, patch } = usePillContent(pill);
  const side = pill.attachTo?.side;
  const isRightAnchor = side === 'right';
  const setAccessor = isRightAnchor ? setPillPaddingLeft : setPillPaddingRight;
  const key = isRightAnchor ? 'paddingLeft' : 'paddingRight';

  const [value, setValue] = useState(0);

  useEffect(() => {
    if (content) setValue((isRightAnchor ? content.paddingLeft : content.paddingRight) ?? content.paddingX);
  }, [content, isRightAnchor]);

  if (!side) return null;

  return (
    <div style={sectionStyle}>
      <div style={labelStyle}>Padding del anclaje</div>
      <div style={rowStyle}>
        <span style={{ ...labelStyle, minWidth: 70, marginBottom: 0 }}>
          {isRightAnchor ? 'Lado izq.' : 'Lado der.'}
        </span>
        <input
          type='range'
          min={0}
          max={200}
          step={1}
          value={value}
          onChange={e => {
            const v = Number(e.target.value);
            setValue(v);
            setAccessor(pill, v); // preview
          }}
          onPointerUp={() => patch({ [key]: value })}
          style={sliderStyle}
        />
        <span style={valueLabelStyle}>{value.toFixed(0)}px</span>
      </div>
    </div>
  );
};
